<script lang="ts">
	import { onMount } from 'svelte';
	import GlobalMedia from '../media/GlobalMedia.svelte';
	import Text from '../Text.svelte';

	// Add your TypeScript code here
	export let label: string = '';
	export let labelKey: string | undefined = undefined;

	export let defaultOpen: boolean = true;

	let isOpen = defaultOpen;
	let content: HTMLDivElement;

	function toggle() {
		isOpen = !isOpen;
	}

	function updateMaxHeight(..._args: any[]) {
		if (!content) return;
		content.style.maxHeight = isOpen ? `${content.scrollHeight}px` : '0px';
	}

	onMount(() => {
		updateMaxHeight();
	});

	$: updateMaxHeight(isOpen);
	let observer: any;
	onMount(() => {
		observer = new ResizeObserver(() => updateMaxHeight());
		if (content) observer.observe(content);

		return () => observer.disconnect();
	});
</script>

<svelte:window on:resize={updateMaxHeight} />

<div class="collapse-item" class:open={isOpen}>
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div class="header" on:click={toggle}>
		<slot name="header-before" />

		<div class="label">
			{#if labelKey}
				<Text key={labelKey} />
			{:else}
				{label}
			{/if}
		</div>
		<div class="icon">
			<div class="line" />
			<div class="line" />
		</div>

		<slot name="header-after" />
	</div>
	<div class="content" class:hidden={!isOpen} bind:this={content}>
		<slot />
	</div>
</div>

<style lang="scss">
	.collapse-item:not(.open) {
		.header {
			.icon {
				.line {
					&:last-child {
						transform: rotate(-90deg);
					}
				}
			}
		}

		.content {
			margin-top: 0;
			opacity: 0;
		}
	}

	.collapse-item {
		padding-bottom: v(content-gap-sm);
		// padding-top: v(content-gap-sm);

		border-bottom: 1px solid color(grey_03);
	}

	.header {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: v(content-gap-sm);

		.label {
			@include font(h5);
		}

		.icon {
			width: 1rem;
			height: 1em;
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;

			.line {
				position: absolute;
				width: 100%;
				height: 2px;
				background-color: color(black);
				@include transition(all);
			}
		}
	}

	.content {
		overflow: hidden;
		@include transition(all);
		margin-top: v(content-gap-sm);
		@include font(text);

		// &.hidden {
		// 	max-height: 0px !important;
		// }
	}
	/* Add your SCSS styles here */
</style>
